import React from "react";

import AuthRedirect from "./authRedirect";

import DefaultLayout from "../layouts/defaultLayout";
import PublicLayout from "../layouts/publicLayout";

import Login from "../features/account/login";
import Register from "../features/account/register";
import EmailConfirmation from "../features/account/emailConfirmation";
import EmailVerification from "../features/account/emailVerification";
import RecoverPassword from "../features/account/recoverPassword";
import RecoverPasswordConfirmation from "../features/account/recoverPasswordConfirmation";
import ResetPassword from "../features/account/resetPassword";
import ResetPasswordConfirmation from "../features/account/resetPasswordConfirmation";
import CarCustomizer from "../features/product/carCustomizer";
import Cart from "../features/cart";
import Checkout from "../features/checkout";
import PaymentSuccess from "../features/payment/success";
import PaymentFailure from "../features/payment/failure";

import TermsAndConditions from "../features/content/termsConditions";
import PrivacyPolicy from "../features/content/privacyPolicy";
import RefundPolicy from "../features/content/refundPolicy";
import ShippingPolicy from "../features/content/shippingPolicy";
import AboutUs from "../features/content/aboutUs";
import ContactUs from "../features/content/contactUs";

import PageNotFound from "../features/error/pageNotFound";
import AccessDenied from "../features/error/accessDenied";
import LoginWithOTP from "../features/account/loginWithOtp";

const PublicRoutes = [
  {
    element: <PublicLayout />,
    path: "/",
    children: [
      {
        // path: "car-customizer",
        path: "/",
        element: <CarCustomizer />,
      },
      {
        path: "cart",
        element: <Cart />,
      },
      {
        path: "checkout",
        element: <Checkout />,
      },
      {
        path: "payment-success/:orderId",
        element: <PaymentSuccess />,
      },
      {
        path: "payment-failure",
        element: <PaymentFailure />,
      },
      {
        path: "terms-and-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "refund-returns",
        element: <RefundPolicy />,
      },
      {
        path: "shipping-policy",
        element: <ShippingPolicy />,
      },
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
    ],
  },
  {
    element: <DefaultLayout />,
    path: "/",
    children: [
      {
        path: "login",
        element: (
          <AuthRedirect>
            <Login />
          </AuthRedirect>
        ),
      },
      {
        path: "register",
        element: (
          <AuthRedirect>
            <Register />
          </AuthRedirect>
        ),
      },
      {
        path: "confirm-email",
        element: (
          <AuthRedirect>
            <EmailConfirmation />
          </AuthRedirect>
        ),
      },
      {
        path: "verify-email",
        element: (
          <AuthRedirect>
            <EmailVerification />
          </AuthRedirect>
        ),
      },
      {
        path: "recover-password",
        element: (
          <AuthRedirect>
            <RecoverPassword />
          </AuthRedirect>
        ),
      },
      {
        path: "recover-password-confirmation",
        element: (
          <AuthRedirect>
            <RecoverPasswordConfirmation />
          </AuthRedirect>
        ),
      },
      {
        path: "reset-password",
        element: (
          <AuthRedirect>
            <ResetPassword />
          </AuthRedirect>
        ),
      },
      {
        path: "reset-password-confirmation",
        element: (
          <AuthRedirect>
            <ResetPasswordConfirmation />
          </AuthRedirect>
        ),
      },   
      {
        path: "login-with-otp",
        element: (
          <AuthRedirect>
            <LoginWithOTP />
          </AuthRedirect>
        ),
      },   
      {
        path: "access-denied",
        element: <AccessDenied />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
];

export default PublicRoutes;
